import angular from 'angular';
import Model from '../model';

function TreeModelFactory(Model) {
  return class TreeModel extends Model {
    constructor(Grouping) {
      super(new Array());
      this.grouping = Grouping;
    }
    findExcluded(node, excluded, groups) {
      if (node.excluded === excluded) {
        groups.push(node.id);
      }
      if (node.children && node.children.length !== 0) {
        node.children.forEach(child => {
          this.findExcluded(child, excluded, groups);
        });
      }
    }
    findCollapsed(node, collapsed, groups) {
      if (node.collapsed === collapsed) {
        groups.push(node.id);
      }
      if (node.children && node.children.length !== 0) {
        node.children.forEach(child => {
          this.findCollapsed(child, collapsed, groups);
        });
      }
    }
    setExcludedByQuery(viewBy) {
      if (viewBy.includes && viewBy.includes.length === 0 &&
        viewBy.excludes && viewBy.excludes.length === 0) {
        this.setAllExcluded(true);
      } else if (viewBy.includes && viewBy.includes.length > 0) {
        this.setAllExcluded(true);
        this.findIds(viewBy.includes).forEach(node => {
          if (node) {
            node.excluded = false;
          }
        });
      } else {
        this.findIds(viewBy.excludes).forEach(node => {
          if (node) {
            node.excluded = true;
          }
        });
      }
    }
    setCollapsedByQuery(viewBy) {
      if (viewBy.uncollapsed && viewBy.uncollapsed.length === 0 &&
        viewBy.collapsed && viewBy.collapsed.length === 0) {
        this.setAllCollapsed(true);
      } else if (viewBy.uncollapsed && viewBy.uncollapsed.length > 0) {
        this.setAllCollapsed(true);
        this.findIds(viewBy.uncollapsed).forEach(node => {
          if (node) {
            node.collapsed = false;
          }
        });
      } else {
        this.findIds(viewBy.collapsed).forEach(node => {
          if (node) {
            node.collapsed = true;
          }
        });
      }
    }
    findAllExcluded(viewBy) {
      if ((viewBy.includes && viewBy.includes.length === 0 &&
          viewBy.excludes && viewBy.excludes.length === 0) ||
        (viewBy.includes && viewBy.includes.length > 0)) {
        viewBy.includes = [];
        this.data.forEach(node => {
          this.findExcluded(node, false, viewBy.includes);
        });
        viewBy.excludes = [];
      } else {
        viewBy.excludes = [];
        this.data.forEach(node => {
          this.findExcluded(node, true, viewBy.excludes);
        });
        viewBy.includes = null;
      }
      return viewBy;
    }
    findAllCollapsed(viewBy) {
      if ((viewBy.uncollapsed && viewBy.uncollapsed.length === 0 &&
          viewBy.collapsed && viewBy.collapsed.length === 0) ||
        (viewBy.uncollapsed && viewBy.uncollapsed.length > 0)) {
        viewBy.uncollapsed = [];
        this.data.forEach(node => {
          this.findCollapsed(node, false, viewBy.uncollapsed);
        });
        viewBy.collapsed = [];
      } else {
        viewBy.collapsed = [];
        this.data.forEach(node => {
          this.findCollapsed(node, true, viewBy.collapsed);
        });
        viewBy.uncollapsed = null;
      }
      return viewBy;
    }

    toGroup(node, parentsArray = [], groups) {
      // drill-down and accumulate parents (in order to set names)

      parentsArray.push(node);

      if (!node.excluded) {
        groups.push({
          id: node.id,
          displayName: parentsArray.map(parent => parent.displayName).join(
            ' / '),
          facts: []
        });
      }

      if (node.children && node.children.length !== 0) {
        node.children.forEach(child => {
          this.toGroup(child, parentsArray, groups);
        });
      }
    }
    toGroups() {
      var groups = [];
      // convert tree to 1d array (single level)
      this.data.forEach(node => {
        this.toGroup(node, [], groups);
      });

      return groups;
    }
    findNode(id, tree, parentsArray = []) {
      if (!tree) {
        tree = this.data;
      }

      for (var i = 0; i < tree.length; i++) {

        if (tree[i].id === id) {
          parentsArray.push(tree[i]);
          tree[i].headerDisplayName = parentsArray.map(parent => parent.displayName)
            .join(' / ');
          return tree[i];
        }
        if (tree[i].children && tree[i].children.length !== 0) {
          parentsArray.push(tree[i]);
          let val = this.findNode(id, tree[i].children, parentsArray);
          if (val) {
            return val;
          } else {
            parentsArray.pop();
          }
        }
      };
    }
    sortNodes(a, b, tree) {
      // returns sort order int based on which node is found first
      if (a.id === b.id) {
        return 0;
      }
      if (!tree) {
        tree = this.data;
      }

      for (var i = 0; i < tree.length; i++) {
        if (tree[i].id === a.id) {
          return -1;
        } else if (tree[i].id === b.id) {
          return 1;
        } else if (tree[i].children && tree[i].children.length !== 0) {
          let match = this.sortNodes(a, b, tree[i].children);
          if (match) {
            return match;
          }
        }
      }
    }
    findIds(array) {
      return array.map(id => this.findNode(id));
    }

    setExcluded(node, excluded) {
      if (typeof excluded === 'undefined') {
        excluded = !node.excluded;
      }
      node.excluded = excluded;
      if (node.children && node.children.length !== 0) {
        node.children.forEach(child => {
          this.setExcluded(child, excluded);
        });
      }
    }
    toggleExcluded(node) {
      this.setExcluded(node, !node.excluded);
      this.setData(this.data);
    }
    setAllExcluded(excluded) {
      this.data.forEach(node => {
        this.setExcluded(node, excluded);
      });
      this.setData(this.data);
    }
    setCollapsed(node, collapsed) {
      if (typeof collapsed === 'undefined') {
        collapsed = !node.collapsed;
      }
      node.collapsed = collapsed;
      if (node.children && node.children.length !== 0) {
        node.children.forEach(child => {
          this.setCollapsed(child, collapsed);
        });
      }
    }
    toggleCollapsed(node) {
      this.setCollapsed(node, !node.collapsed);
      this.setData(this.data);
    }
    setAllCollapsed(collapsed) {
      this.data.forEach(node => {
        this.setCollapsed(node, collapsed);
      });
      this.setData(this.data);
    }

    set(item) {
      // find item in tree and replace it
      this.data.set(item.id, item);
    }

    add(item, parent = {}) {
      item.children = item.children || [];
      parent.children = parent.children || [];
      if (parent.id) {
        parent.children.push(item);
      } else if (!(this.data.some(i => i.id === item.id))) {
        this.data.push(item);
      }
    }
    remove(item, array) {
      if (!array) {
        array = this.data;
      }
      var index;
      for (var i = 0; i < array.length; i++) {
        if (array[i].id === item.id) {
          index = i;
        }
      };
      if (index > -1) {
        array.splice(index, 1);
      } else {
        array.forEach(node => {
          if (node.children && node.children.length !== 0) {
            this.remove(item, node.children);
          }
        });
      }

    }
    get(id) {
      return this.data.get(id)
    }
  }
}
TreeModelFactory.$inject = ['Model'];

export default angular.module('trees.tree', [Model])
  .factory('TreeModel', TreeModelFactory)
  .name;



// WEBPACK FOOTER //
// ./project/models/trees/tree.js